import httpClient from './httpClient';

export const ORDER_AUTO_COMPLETE_ENDPOINT = '/backoffice/order-auto-complete-settings';

export const getOrderAutoCompleteListAPI = (params = {}) => httpClient.get(`${ORDER_AUTO_COMPLETE_ENDPOINT}`, { params });
export const updateOrderAutoCompleteListAPI = (payload = {}) => httpClient.put(`${ORDER_AUTO_COMPLETE_ENDPOINT}`, payload);
